// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `body {
  background-color: #f3fffe !important;
  width: 100%;
  height: 100%;
  margin: 0px;
  padding: 0px;
}

* {
  font-family: 'Plus Jakarta Sans', sans-serif;
}

.story-containerer {
  padding-top: 2rem;
}

.nav-hover:hover {
  opacity: 0.5;
}
`, "",{"version":3,"sources":["webpack://./src/styles/main.css"],"names":[],"mappings":"AAAA;EACE,oCAAoC;EACpC,WAAW;EACX,YAAY;EACZ,WAAW;EACX,YAAY;AACd;;AAEA;EACE,4CAA4C;AAC9C;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,YAAY;AACd","sourcesContent":["body {\n  background-color: #f3fffe !important;\n  width: 100%;\n  height: 100%;\n  margin: 0px;\n  padding: 0px;\n}\n\n* {\n  font-family: 'Plus Jakarta Sans', sans-serif;\n}\n\n.story-containerer {\n  padding-top: 2rem;\n}\n\n.nav-hover:hover {\n  opacity: 0.5;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
